/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { PayloadAction } from "@reduxjs/toolkit";
import { IEventFilterState } from "../types";
import { IGeoRegion } from "../../api/admin/types";

export const setSelectedEventSeverityAction = (state: IEventFilterState, action: PayloadAction<string>) => {
  state.selectedEventSeverity = action.payload;
};

export const setSelectedManagedObjectAction = (state: IEventFilterState, action: PayloadAction<string>) => {
  state.selectedManagedObject = action.payload;
};
export const setSelectedEventTypeAction = (state: IEventFilterState, action: PayloadAction<string>) => {
  state.selectedEventType = action.payload;
};

export const setSelectedEventTimeAction = (state: IEventFilterState, action: PayloadAction<number>) => {
  state.selectedEventTime = action.payload;
};

export const setSelectedFromEventTimeAction = (state: IEventFilterState, action: PayloadAction<number>) => {
  state.selectedFromEventTime = action.payload;
};

export const setSelectedToEventTimeAction = (state: IEventFilterState, action: PayloadAction<number>) => {
  state.selectedToEventTime = action.payload;
};

export const setSelectedDeviceKpiAction = (state: IEventFilterState, action: PayloadAction<string>) => {
  state.pmCollected = action.payload;
};

export const setSelectedLabelsAction = (state: IEventFilterState, action: PayloadAction<string[]>) => {
  state.selectedLabels = action.payload;
};

export const resetEventFiltersAction = (state: IEventFilterState) => {
  state.selectedEventSeverity = "";
  state.selectedEventAcknowledged = "";
  state.selectedManagedObject = "";
  state.selectedEventType = "";
  state.selectedEventTime = 0;
  state.selectedFromEventTime = 0;
  state.selectedToEventTime = 0;
  state.selectedHostName = "";
  state.selectedMaintenanceMode = "";
  state.pmCollected = "";
  state.selectedDeviceStatus = "";
  state.isDeviceDetailPage = window.location.pathname.split('/')[1]?.toLowerCase() === "device" ? true : false;
  state.geoRegion = { objectKey: "", name: "-" };
  state.selectedLabels = [];
  state.regionFilterIds = [];
};

export const setSelectedHostNameAction = (state: IEventFilterState, action: PayloadAction<string>) => {
  state.selectedHostName = action.payload;
};

export const setSelectedMaintenanceModeAction = (state: IEventFilterState, action: PayloadAction<string>) => {
  state.selectedMaintenanceMode = action.payload;
};

export const setParentKeyAction = (state: IEventFilterState, action: PayloadAction<string>) => {
  state.parentKey = action.payload;
};

export const setSelectedDeviceStatusAction = (state: IEventFilterState, action: PayloadAction<string>) => {
  state.selectedDeviceStatus = action.payload;
};

export const setIsDeviceDetailPageAction = (state: IEventFilterState, action: PayloadAction<boolean>) => {
  state.isDeviceDetailPage = action.payload;
};

export const setGeoRegionAction = (state: IEventFilterState, action: PayloadAction<IGeoRegion>) => {
  state.geoRegion = action.payload;
};

export const setRegionFilterIdsAction = (state: IEventFilterState, action: PayloadAction<string[]>) => {
  state.regionFilterIds = action.payload;
};

